<template>
  <a-input
    v-bind="$attrs"
    :value="displayValue"
    @input="onInput"
    @blur="onBlur"
  />
</template>

<script>
export default {
  name: 'MaskedInput',
  inheritAttrs: false,

  props: {
    value: String,
    viewMode: Boolean,
    maskFn: {
      type: Function,
      required: true
    }
  },

  computed: {
    displayValue() {
      return this.viewMode ? this.maskFn(this.value) : this.value;
    }
  },

  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },

    onBlur(event) {
      // Only forward blur if parent listens
      if (this.$listeners.blur) {
        this.$emit('blur', event);
      }
    }
  }
};
</script>
